import { GET_ADMIN_IMAGES } from "../actions/AdminImagesActions";

const initialState = {
    admin_image_array: {}
};

const adminImagesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ADMIN_IMAGES:
            return {
                ...state,
                admin_image_array: action.payload
            };

        default:
            return state;
    }
};

export default adminImagesReducer;